var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFirstPage = function SvgFirstPage(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m16.4 17.7-4.8-4.8a1 1 0 0 1-.3-.4v-.9l.3-.3 4.8-4.8c.2-.2.5-.3.8-.3s.6 0 .8.3c.2.2.3.5.3.8s0 .6-.3.8l-4 4 4 4c.2.2.3.4.3.8 0 .3 0 .5-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3m-9.6.9a1.1 1.1 0 0 1-1.2-1.2V6.6a1.1 1.1 0 0 1 1.2-1.1c.3 0 .6 0 .8.3.2.2.3.5.3.8v10.8c0 .3-.1.6-.3.8a1 1 0 0 1-.8.4"
  })));
};
export default SvgFirstPage;